<template>
    <van-panel class="used-car-item">
        <template slot="header">
            <van-image :src="item.img_url" width="100%" @click="goDetail"/>
        </template>
        <van-cell>
            <template slot="title"  @click="goDetail">
                <span v-show="item.state && item.state.state != 1 " class="state-name">[{{ item.state ? item.state.state_name : '' }}]</span>{{ item.title }}
            </template>
            <template slot="label">
                {{ item.licensing_date + '  |  ' + drivenDistance + '公里  |  ' + item.area_name + '  |  ' + item.discharge_standard }} 
                <div class="amount">
                    <span class="price">
                        ¥{{ totalAmount }}万元
                    </span>
                    <span class="price-info">
                        {{ item.financial_mortgage }}
                    </span>
                </div>
                <slot name="bottom" />
            </template>
        </van-cell>
    </van-panel>
</template>

<script>
import { 
    Panel,
    Image,
    Row,
    Col,
    Cell
} from 'vant'
import { toThousandsNoDecimal, toThousands } from '@/utils/formatutils'
export default {
    name: 'UsedCarListItem',
    components: {
        [Panel.name]: Panel,
        [Image.name]: Image,
        [Row.name]: Row,
        [Col.name]: Col,
        [Cell.name]: Cell
    },
    props: ['item'],
    data() {
        return {}
    },
    computed: {
        totalAmount() {
            // return toThousands((Number(this.item.channel_amount) + Number(this.item.deposit) + Number(this.item.used_car_shop.server_amount))/10000)
            return toThousands((Number(this.item.channel_amount)  + Number(this.item.used_car_shop.server_amount))/10000)
        },
        drivenDistance() {
            return toThousandsNoDecimal(this.item.driven_distance)
        }
    },
    methods: {
        goDetail() {
            console.log('in item')
            this.$router.push(`/nt/usedcar/${this.item.id}/`)
        }
    }
}
</script>

<style lang="less" scoped>
.used-car-item {
    margin: 4px;
    .van-cell__label {
        font-size: 13px;
    }
    .amount {
        .price {
            color: #2196F3;
        }
        .price-info {
            margin-left: 8px;
        }
    }
    .state-name {
        color: red;
    }
}
</style>
